import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { components } from '../api';
import { ApiService } from '../api.service';

export type UserPreferences = components['schemas']['UserPreferences'];
export type UpdateUserPreferencesRequest = components['schemas']['UpdateUserPreferencesRequest'];

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesApi extends ApiService {
  get(): Observable<UserPreferences> {
    return this.request(this.client.GET('/api/user-preferences', {}));
  }

  update(body: UpdateUserPreferencesRequest): Observable<UserPreferences> {
    return this.request(this.client.PATCH('/api/user-preferences', { body }));
  }
}
